module.exports = __webpack_public_path__ + "img/ck-one.006bbf0c.png";